/**
 * RunEditForm — modifier les dates (début, fin, date de paie) et la note d'une période non approuvée (Batch #14.282).
 * Si la période était calculée, les bulletins sont effacés : il faut recalculer.
 */
import { useState } from "react";
import axios from "axios";
import { Save, X } from "lucide-react";
import { toast } from "@/lib/toast";
import { API, authH, inputCls, Field, Btn, err } from "./_shared";

export default function RunEditForm({ masterId, run, onDone, onCancel }) {
  const [f, setF] = useState({ period_start: run.period_start, period_end: run.period_end, pay_date: run.pay_date, note: run.note || "" });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const submit = async () => {
    if (run.status === "calculated" && !window.confirm("Cette période est déjà calculée : les bulletins seront effacés et devront être recalculés. Continuer ?")) return;
    setSaving(true);
    try {
      const r = await axios.put(`${API}/admin/payroll/${masterId}/runs/${run.id}`, f, { headers: authH() });
      toast.success(r.data.recalc_required ? "Période modifiée — à recalculer" : "Période modifiée");
      if (String(r.data.year) !== String(run.year)) toast.message(`La paie du ${r.data.pay_date} classe cette période dans l'année ${r.data.year}`);
      onDone(r.data);
    } catch (e) { err(e); } finally { setSaving(false); }
  };
  return (
    <div className="bg-white border-2 border-sky-200 rounded-xl p-4 space-y-3" data-testid="paie-run-edit-form">
      <div className="text-sm font-bold text-sky-900">Modifier la période #{run.year}-{String(run.sequence).padStart(3, "0")}</div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <Field label="Début de période"><input type="date" className={inputCls} value={f.period_start} onChange={(e) => set("period_start", e.target.value)} data-testid="paie-run-edit-start" /></Field>
        <Field label="Fin de période"><input type="date" className={inputCls} value={f.period_end} onChange={(e) => set("period_end", e.target.value)} data-testid="paie-run-edit-end" /></Field>
        <Field label="Date de paie" hint="Telle quelle, même un férié ou une fin de semaine"><input type="date" className={inputCls} value={f.pay_date} onChange={(e) => set("pay_date", e.target.value)} data-testid="paie-run-edit-pay-date" /></Field>
        <Field label="Note"><input className={inputCls} value={f.note} onChange={(e) => set("note", e.target.value)} maxLength={500} data-testid="paie-run-edit-note" /></Field>
      </div>
      <div className="flex flex-col-reverse sm:flex-row gap-2 sm:justify-end">
        <Btn tone="slate" icon={X} onClick={onCancel} testId="paie-run-edit-cancel">Annuler</Btn>
        <Btn tone="sky" icon={Save} onClick={submit} busy={saving} testId="paie-run-edit-save">Enregistrer</Btn>
      </div>
    </div>
  );
}
